// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const RuleWorkflow = lazy(() => import('pages/ruleWorkflow/ruleWorkflow'));
const RuleWorkflowList = lazy(() => import('pages/ruleWorkflow/list'));

const RuleWorkflowRoute = (
  <Route path={routeName.RuleWorkflow}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.ALL_GRID_APPROVAL_WORKFLOW_VIEW,
            PrivateRouteConst.SELF_GRID_APPROVAL_WORKFLOW_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleWorkflowList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_GRID_APPROVAL_WORKFLOW}>
          <Suspense fallback={<Loading />}>
            <RuleWorkflow type="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.ALL_GRID_APPROVAL_WORKFLOW_EDIT,
            PrivateRouteConst.SELF_GRID_APPROVAL_WORKFLOW_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleWorkflow type="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.ALL_GRID_APPROVAL_WORKFLOW_VIEW,
            PrivateRouteConst.SELF_GRID_APPROVAL_WORKFLOW_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RuleWorkflow type="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RuleWorkflowRoute;
